module.exports = __webpack_public_path__ + "static/media/img_47.9f2a3cc7.png";